<template>
  <div class="p-col-12">
    <div class="card">
      <form name="taskForm" class="p-col-12" @submit.prevent="submitTaskForm">
        <div class="p-fluid p-formgrid p-grid">
          <div
            class="p-field p-col-12 p-md-6"
            v-if="
              task.action == 'create' ||
              (task.action == 'update' &&
                task.isBooking == true &&
                task.type == 1)
            "
          >
            <SelectButton
              v-model="task.taskType"
              :options="selectButtonOptions()"
              optionLabel="name"
              optionValue="value"
              @input="typeFormChanged"
            />
          </div>
          <div
            v-if="task.action == 'update'"
            class="p-field p-col-12 p-md-12"
            style="margin-top: 10px"
          >
            <span class="p-float-label">
              <Dropdown
                v-model="task.usersSelecteds"
                name="user"
                v-validate="'required'"
                v-bind:class="[
                  { 'p-error': errors.has('user') },
                  'form-control',
                ]"
                :inputId="'user'"
                :options="myUsers"
                :optionLabel="getUserSearchLabel"
                :optionValue="'id'"
                :dataKey="'id'"
                :filter="true"
                :required="true"
              >
                <template #option="slotProps">
                  {{ slotProps.option.username }}
                </template>
              </Dropdown>
              <label for="inputtext">Funcionário</label>
            </span>
          </div>

          <div
            v-if="task.action == 'view'"
            class="p-field p-col-12 p-md-12"
            style="margin-top: 10px"
          >
            <span class="p-float-label">
              <InputText
                type="text"
                v-model="task.technician"
                :disabled="true"
              />
              <label for="inputtext">Funcionário</label>
            </span>
          </div>

          <div
            v-if="task.action == 'create'"
            class="p-field p-col-12 p-md-12"
            style="margin-top: 10px"
          >
            <span class="p-float-label">
              <MultiSelect
                name="usersSelecteds"
                inputId="usersSelectedsInput"
                :options="myUsers"
                :filter="true"
                :optionLabel="getUserSearchLabel"
                v-model="task.usersSelecteds"
                v-validate="'required'"
                display="chip"
              >
                <template #option="slotProps">
                  {{ slotProps.option.username }}
                </template>
              </MultiSelect>
              <label for="inputtext">Selecionar Funcionário</label>
            </span>
            <small
              v-if="errors.has('usersSelecteds')"
              class="p-error"
              role="alert"
              >Funcionário é obrigatório</small
            >
          </div>

          <div class="p-field p-col-12 p-md-4" style="margin-top: 10px">
            <div class="p-inputgroup">
              <span class="p-inputgroup-addon">
                <i class="pi pi-calendar"></i>
              </span>
              <span class="p-float-label">
                <v-date-picker
                  :disabled="task.action == 'view'"
                  name="day"
                  id="day"
                  v-model="task.day"
                  v-validate="'required'"
                  :min-date="new Date()"
                  :masks="{
                    input: 'YYYY-MM-DD',
                  }"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <span class="p-float-label">
                      <input
                        :disabled="task.action == 'view'"
                        v-bind:class="[
                          {
                            'p-error': errors.has('day'),
                          },
                          'form-control',
                          'p-inputtext',
                          'p-component',
                          'p-filled',
                        ]"
                        :value="inputValue"
                        v-on="inputEvents"
                      />
                      <label for="inputtext">Dia</label>
                    </span>
                  </template>
                </v-date-picker>
              </span>
              <small v-if="errors.has('day')" class="p-error" role="alert"
                >Dia é obrigatório</small
              >
            </div>
          </div>

          <div class="p-field p-col-12 p-md-4" style="margin-top: 10px">
            <div class="p-inputgroup">
              <span class="p-inputgroup-addon">
                <i class="pi pi-clock"></i>
              </span>
              <span class="p-float-label">
                <Calendar
                  :disabled="task.action == 'view'"
                  id="start"
                  ref="start"
                  v-model="task.start"
                  v-validate="'required|date_format:H:mm'"
                  v-bind:class="[
                    { 'p-error': errors.has('start') },
                    'form-control',
                  ]"
                  :timeOnly="true"
                  :stepMinute="15"
                  name="start"
                />
                <label for="inputtext">Hora de início</label>
              </span>
            </div>
            <small v-if="errors.has('start')" class="p-error" role="alert"
              >Hora de início é obrigatório</small
            >
          </div>

          <div class="p-field p-col-12 p-md-4" style="margin-top: 10px">
            <div class="p-inputgroup">
              <span class="p-inputgroup-addon">
                <i class="pi pi-clock"></i>
              </span>
              <span class="p-float-label">
                <Calendar
                  :disabled="task.action == 'view'"
                  id="end"
                  v-model="task.end"
                  v-validate="'required|date_format:H:mm|after_start'"
                  v-bind:class="[
                    { 'p-error': errors.has('end') },
                    'form-control',
                  ]"
                  :timeOnly="true"
                  :stepMinute="15"
                  name="end"
                />
                <label for="inputtext">Hora de fim</label>
              </span>
            </div>
            <small v-if="errors.has('end')" class="p-error" role="alert"
              >Hora de fim tem que ser posterior à de início</small
            >
          </div>

          <div
            v-if="
              (task.action == 'create' && !task.isBooking) ||
              (task.action == 'update' &&
                !task.isBooking &&
                task.bookingId != undefined)
            "
            class="p-field p-col-12 p-md-12 p-mt-3"
          >
            <AppAutocomplete
              label="Selecionar PATs"
              v-model="task.selectedPats"
              :fetchFunction="fetchPats"
              :optionLabel="getPatLabel"
              :optionValue="'patNumber'"
              fieldId="supportSelectedPats"
              :multiple="true"
              v-validate.disable="'required'"
              data-vv-name="supportSelectedPats"
            >
              <template #option="slotProps">
                <div>
                  <b>PAT:</b>
                  {{ slotProps.option.patNumber }} | {{ slotProps.option.typename }}
                  <br />
                  <span style="white-space: normal;word-break: break-word;" v-if="slotProps.option.patTitle">
                    <b>Título:</b> {{ slotProps.option.patTitle }}
                  </span>
                </div>
              </template>
            </AppAutocomplete>
            <small v-if="errors.has('supportSelectedPats')" class="p-error" role="alert">
              Selecione pelo menos um PAT
            </small>
          </div>

          <div
            v-if="formattedPatNumber.length > 0"
            class="p-field p-col-12 p-md-12 p-mt-2"
          >
            <span class="p-float-label">
              <InputText
                type="text"
                :value="formattedPatNumber"
                :disabled="true"
              />
              <label for="inputtext">
                {{ "PAT" }}
              </label>
            </span>
          </div>

          <div
            class="p-field p-col-12 p-md-12 p-mt-2"
            v-if="task.action != 'create' && Object.keys(task.task_all_info).includes('pat_problem')"
          >
            <span class="p-float-label">
              <Textarea
                id="pat_problem"
                name="pat_problem"
                :disabled="true"
                :autoResize="true"
                v-model="task.task_all_info.pat_problem"
                v-bind:class="['p-inputtextarea', 'p-inputtext', 'p-component']"
                rows="5"
              />
              <label for="inputtext">Problema</label>
            </span>
          </div>

          <div class="p-field p-col-12 p-md-12" style="margin-top: 10px">
            <span class="p-float-label">
              <Textarea
                id="note"
                name="note"
                :disabled="task.action == 'view'"
                :autoResize="true"
                v-model="task.note"
                v-bind:class="[
                  { 'p-error': errors.has('note') },
                  'p-inputtextarea',
                  'p-inputtext',
                  'p-component',
                ]"
                rows="5"
              />
              <label for="inputtext">Notas</label>
            </span>
          </div>

          <div
            class="p-field p-col-12 p-md-6"
            v-if="task.localization instanceof Object"
            style="color: #767f86"
          >
            <h4>Morada:</h4>
            <div class="p-field p-md-12">
              {{ task.localization.address }} <br />
              {{ task.localization.zip_code }} - {{ task.localization.local }}
            </div>
            <div class="p-field p-col-12 p-md-4">
              <Button
                label="Ver no mapa"
                class="p-button-raised p-button-text"
                icon="pi pi-map-marker"
                @click="goToAdrress"
              />
            </div>
          </div>

          <div class="p-col-12 p-grid p-mb-3">
            <div
              class="p-field p-col-12 p-md-3"
              v-if="!task.isBooking"
            >
              <div class="p-mb-2">Confirmado:</div>
              <InputSwitch
                v-model="task.marcada"
                style="'top: 3px;"
              />
            </div>

            <div
              class="p-field p-col-12 p-md-3"
              v-if="!task.isBooking && can('useSmsNotifications')"
            >
              <div class="p-mb-2">Enviar SMS de confirmação:</div>
              <InputSwitch
                v-model="notify_sms_confirmation"
                style="'top: 3px;"
              />
            </div>

            <div
              class="p-field p-col-12 p-md-4"
              v-if="!task.isBooking && task.action != 'view'"
            >
              <div class="p-mb-2">Guardar notas na solução do PAT:</div>
              <InputSwitch v-model="save_notes_to_pat_solution" />
            </div>

            <div
              class="p-field p-col-12 p-md-6"
              v-if="!task.isBooking && can('useSmsNotifications') && notify_sms_confirmation && task.action == 'update'"
            >
              <div class="p-mb-2">Número de contacto:</div>
              <Dropdown
                v-model="notify_sms_phone"
                :options="clientContacts"
                optionLabel="label"
                optionValue="phone"
                placeholder="Selecione ou introduza um número"
              />
            </div>
          </div>

          <div
            class="p-field p-col-12 p-md-12 p-text-right"
            style="color: #91969a"
            v-if="task.action != 'create'"
          >
            <small>
              Criado por {{ task.created_by }} {{ task.created_at }} <br />
              Última alteração por {{ task.updated_by }} {{ task.updated_at }}
            </small>
          </div>

          <div class="p-grid p-jc-center p-col-12">
            <div v-if="task.action != 'view'" class="p-col-12 p-md-3 p-mt-2">
              <Button
                icon="pi pi-check"
                label="Guardar"
                class="p-button-success"
                @click="submitTaskForm()"
              />
            </div>
            <div class="p-col-12 p-md-3 p-mt-2">
              <Button
                icon="pi pi-times"
                label="Cancelar"
                @click="cancelTaskForm()"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import VeeValidate from "vee-validate";
import AppAutocomplete from "@/components/elements/AppAutocomplete.vue";
import interventionService from "../services/intervention.service";

export default {
  name: "SupportForm",
  components: { AppAutocomplete },
  props: ["task", "interventionTypes", "myUsers"],
  data() {
    return {
      loading: false,
      message: "",
      searchItems: [],
      today: new Date(),
      notify_sms_confirmation: false,
      save_notes_to_pat_solution: false,
      notify_sms_phone: "",
      clientContacts: [],
    };
  },
  watch: {
    task() {
      this.save_notes_to_pat_solution = false;
    },
    notify_sms_confirmation(val) {
      if (val) {
        this.loadClientContacts();
      }
    },
  },
  created() {
    VeeValidate.Validator.extend("after_start", {
      validate: () =>
        new Promise((resolve) => {
          let day = new Date();
          if (!(this.task.day instanceof Date)) {
            day = new Date(this.task.day);
          } else {
            day = this.task.day;
          }

          if (!(this.task.start instanceof Date)) {
            let newStart = new Date();
            newStart.setSeconds(0);
            newStart.setHours(this.task.start.split(":")[0]);
            newStart.setMinutes(this.task.start.split(":")[1]);
            this.task.start = newStart;
          }
          if (!(this.task.end instanceof Date)) {
            let newEnd = new Date();
            newEnd.setSeconds(0);
            newEnd.setHours(this.task.end.split(":")[0]);
            newEnd.setMinutes(this.task.end.split(":")[1]);
            this.task.end = newEnd;
          }

          this.task.start.setFullYear(
            day.getFullYear(),
            day.getMonth(),
            day.getDate()
          );
          this.task.end.setFullYear(
            day.getFullYear(),
            day.getMonth(),
            day.getDate()
          );
          resolve({
            valid: this.task.end > this.task.start,
          });
        }),
    });
  },
  computed: {
    formattedPatNumber() {
      if (!this.task.patNumber) return "";
      let selectedPat = this.task;

      let prefix = selectedPat.taskType === 4 ? "Issue" : "PAT";
      let title = selectedPat.patTitle || "";

      return `${prefix} ${selectedPat.patNumber} - ${title}`;
    }
  },
  methods: {
    submitTaskForm() {
      this.loading = true;

      this.$validator.validateAll().then((isValid) => {
        if (!isValid) {
          this.loading = false;
          return;
        }

        this.task.pat_numbers = Array.isArray(this.task.selectedPats)
        ? this.task.selectedPats.map(p => typeof p === 'object' ? p.patNumber : p)
        : [];

        const sendSms = this.notify_sms_confirmation;
        this.task.notify_sms_confirmation = sendSms;
        this.task.notify_sms_phone = (sendSms && this.task.action == 'update') ? this.notify_sms_phone : null;
        this.task.save_notes_to_pat_solution = !this.task.isBooking && this.save_notes_to_pat_solution;

        this.$emit("submitTaskForm", this.task);
      });
    },
    cancelTaskForm() {
      this.$emit("cancelTaskForm");
    },
    getPatLabel(info) {
      if (!info) { return ''; }
      let prefix = info.typeId === 4 ? "Issue" : "PAT";
      let title = info.patTitle || "";

      if (title.length > 15) {
        title = title.slice(0, 15) + "...";
      }
      return `${prefix} ${info.patNumber} - ${title}`;
    },
    async fetchPats(search = '') {
      try {
        let pats = await interventionService.queryPats({
          'types': this.interventionTypes.map(e => e.id),
          'search': search
        });

        return pats;
      } catch (error) {
        console.error('Error fetching PATs:', error);
        throw error;
      }
    },
    getSearchLabel(info) {
      return `${info.typename} ${info.projectName} ${info.patNumber} ${info.patTitle}`;
    },
    getUserSearchLabel(info) {
      return `${info.username}`;
    },
    goToAdrress() {
      window.open(
        `http://maps.google.com/?q=${this.task.localization.address}, ${this.task.localization.zip_code}, ${this.task.localization.local}`,
        "_blank"
      );
    },
    typeFormChanged(areBooking) {
      this.$validator.pause();
      this.$nextTick(() => {
        this.$validator.errors.clear();
        this.$validator.fields.items.forEach((field) => field.reset());
        this.$validator.fields.items.forEach((field) =>
          this.errors.remove(field)
        );
        this.$validator.resume();
      });
      if (areBooking > 0) {
        this.task.isBooking = true;
        this.task.type = areBooking;
        this.task.taskType = areBooking;
        return;
      }
      this.task.isBooking = false;
      this.task.type = null;
    },
    selectButtonOptions() {
      if (this.task.action == "create") {
        return [
          { name: "Tarefa", value: 0 },
          { name: "Reserva", value: 1 },
          { name: "Indisponíbilidade", value: 2 },
        ];
      } else if (
        this.task.action == "update" &&
        this.task.isBooking == true &&
        this.task.type == 1
      ) {
        return [
          { name: "Tarefa", value: 0 },
          { name: "Reserva", value: 1 },
        ];
      } else if (this.task.isBooking == true && this.task.type == 2) {
        return [{ name: "Indisponíbilidade", value: 2 }];
      }
    },
    async loadClientContacts() {
      if (this.task?.action !== 'update') {
        this.clientContacts = [];
        this.notify_sms_phone = "";
        return;
      }

      let patNumber = this.task.patNumber || (Array.isArray(this.task.selectedPats) ? this.task.selectedPats[0] : this.task.selectedPats);
      if (!patNumber) {
        this.clientContacts = [];
        this.notify_sms_phone = "";
        return;
      }
      if (typeof patNumber === 'object') {
        patNumber = patNumber.patNumber;
      }

      try {
        const contacts = await interventionService.getPatContacts(patNumber);
        this.clientContacts = contacts || [];
        if (this.clientContacts.length > 0) {
          this.notify_sms_phone = this.clientContacts[0].phone;
        } else {
          this.notify_sms_phone = "";
        }
      } catch (err) {
        console.error("Error loading PAT contacts:", err);
        this.clientContacts = [];
        this.notify_sms_phone = "";
      }
    },
  },
};
</script>
<style>
.p-dropdown-items li.p-dropdown-item.p-disabled{
  background-color: rgba(255, 0, 0, 0.1) !important;
  cursor: not-allowed !important;
}
</style>
